import { EventCatalogFromKeys, EventType } from "../../../types";

export const VolunteerEngagementEventKeys = {
  ADMIN_VOLUNTEER_ENGAGEMENT_PAGE_VIEW: "admin-volunteer-engagement-page-view",
  ADMIN_VOLUNTEER_ENGAGEMENT_PAGE_VIEW_ORGANIZATION_REQUIRED:
    "admin-volunteer-engagement-page-view-organization-required",
} as const;

export const VolunteerEngagementEventCatalog: EventCatalogFromKeys<
  typeof VolunteerEngagementEventKeys
> = {
  [VolunteerEngagementEventKeys.ADMIN_VOLUNTEER_ENGAGEMENT_PAGE_VIEW]: {
    description: "Admin viewed the volunteer engagement page",
    eventType: EventType.PAGE_VIEW,
    id: VolunteerEngagementEventKeys.ADMIN_VOLUNTEER_ENGAGEMENT_PAGE_VIEW,
  },
  [VolunteerEngagementEventKeys.ADMIN_VOLUNTEER_ENGAGEMENT_PAGE_VIEW_ORGANIZATION_REQUIRED]:
    {
      description:
        "Admin viewed the volunteer engagement page but organization is required",
      eventType: EventType.PAGE_VIEW,
      id: VolunteerEngagementEventKeys.ADMIN_VOLUNTEER_ENGAGEMENT_PAGE_VIEW_ORGANIZATION_REQUIRED,
    },
};
